<template>
  <section class="signature-requested">
    <UnifiedFilterSearch
      :filterList="filterList"
      :itensFilter="itensFilter"
      :activeTab="activeTab"
      isNotOpenStackeholderSearch
      bookmarkType="bookmarks_requested"
      :tabPersistName="tabPersistName"
      @search-value="setSearchValue"
      @filters="setFilterList"
    />

    <div class="level">
      <div class="level-left has-text-left">
        <span class="has-text-weight-semibold">
          {{ getPaginationDetails }}
        </span>
      </div>
      <div class="level-right">
        <div v-if="!isValidSelection" class="buttons">
          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            role="button"
            :aria-description="General.ARIA_LABEL.BATCH_CANCEL_SIGNATURE"
            @click="cancelSignatureModal"
          >
            <span class="is-size-8">
              {{ General.CANCEL_REQUEST }}
            </span>
          </b-button>

          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            role="button"
            :aria-description="General.ARIA_LABEL.DOCS_DOWNLOAD"
            @click="checkIsConfidential(getSignatureListCompleteFile)"
          >
            <span>
              {{ General.EXPORT_PDF }}
            </span>
          </b-button>
        </div>
      </div>
    </div>
    <div v-if="observerPage" class="middle">
      <b-table
        class="custom-table-process-panel custom-table-7-columns"
        :data="isLoading ? [] : getDocumentRequestedSignList.list"
        :sortIcon="sortIcon"
        :sortIconSize="sortIconSize"
        :checkedRows.sync="documentsSelectedSignRequested"
        :aria-next-label="General.NEXT_PAGE"
        :aria-previous-label="General.PREVIOUS_PAGE"
        :aria-page-label="General.PAGE"
        :aria-current-label="General.CURRENT_PAGE"
        :defaultSortDirection="defaultSortOrder"
        :defaultSort="[sortField, sortOrder]"
        backendSorting
        checkable
        :showHeader="!isMobile"
        hoverable
        role="table"
        @sort="onSort"
      >
        <template>
          <b-table-column
            v-slot="props"
            field="priority"
            :label="isMobile ? '' : 'hiddenText'"
            headerClass="icons hidden-text"
            cellClass="icons"
            :sortable="!isMobile"
          >
            <div class="is-flex">
              <b-tooltip
                v-if="isConfidential(props.row)"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                position="is-right"
                :label="secrecyName(props.row)"
                class="ml-5"
                role="tooltip"
              >
                <div class="circle-red">
                  <b-icon
                    type="is-white"
                    icon="lock"
                    customSize="mdi-inherit"
                  />
                </div>
              </b-tooltip>
              <b-tooltip
                v-if="
                  props.row.process_file.process.priority &&
                    subjectIcons[props.row.process_file.process.priority.type]
                "
                :label="props.row.process_file.process.priority.name"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                position="is-right"
              >
                <b-icon
                  v-if="
                    props.row.process_file.process.subject &&
                      subjectIcons[props.row.process_file.process.priority.type]
                  "
                  :type="
                    subjectIcons[props.row.process_file.process.priority.type]
                      .color
                  "
                  :icon="
                    subjectIcons[props.row.process_file.process.priority.type]
                      .icon
                  "
                />
              </b-tooltip>
              <b-tooltip
                :label="General.TEXTS.PROCESS_APPENDER"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                role="tooltip"
                position="is-right"
              >
                <b-icon
                  v-if="props.row.process_file.process.process_join_set"
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  icon="link-variant"
                />
              </b-tooltip>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            class="is-narrow"
            field="process_file__process__nup"
            :label="General.NUP"
            :sortable="!isMobile"
          >
            <div class="has-text-color-8">
              {{
                Number(props.row.process_file.process.nup) > 0
                  ? applyMaskNUP(props.row.process_file.process.nup)
                  : General.TEXTS.NUP_NOT_GENERATED
              }}
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="process_file__attachment_name"
            :label="General.DOCUMENT"
            :sortable="!isMobile"
          >
            <div class="has-text-left">
              <routerLink
                class="has-text-color-8 has-text-weight-semibold is-size-6 custom-pointer"
                role="link"
                rel="search tag"
                :to="
                  `/app/documento/${props.row.process_file.id}?processId=${props.row.process_file.process.id}`
                "
              >
                <b-tooltip
                  :label="props.row.process_file.attachment_name"
                  :type="isContrast ? 'is-white' : 'is-blue-oil'"
                  :active="
                    showDocNameTooltip(props.row.process_file.attachment_name)
                  "
                  class="tooltip-break-word"
                  size="is-large"
                  multilined
                  role="tooltip"
                >
                  <div class="doc-name">
                    {{ props.row.process_file.attachment_name }}
                  </div>
                </b-tooltip>
                <p>
                  {{ General.TYPE }}:
                  <span class="has-text-weight-normal">{{
                    props.row.process_file.document_type !== null
                      ? props.row.process_file.document_type.type
                      : ""
                  }}</span>
                </p>
              </routerLink>

              <div class="has-text-color-8">
                <b-tooltip
                  :label="
                    props.row.capacity
                      ? `${props.row.capacity.entity.abbreviation +
                          '/' +
                          props.row.capacity.abbreviation +
                          ' - ' +
                          props.row.capacity.description}`
                      : ''
                  "
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  position="is-top"
                  :delay="500"
                  role="tooltip"
                >
                  <span>
                    <b class="has-text-weight-semibold">
                      {{ General.ASKED_TO }}
                    </b>
                    {{ props.row.user_name }}
                    <template v-if="props.row.capacity">
                      -
                      {{
                        props.row.capacity.entity.abbreviation +
                          "/" +
                          props.row.capacity.abbreviation.split("/", -1)[1]
                      }}
                    </template>
                  </span>
                </b-tooltip>
              </div>

              <div class="has-text-color-8">
                <span>
                  <b class="has-text-weight-semibold">
                    {{ General.PROCESS }}:
                  </b>
                  {{ props.row.process_file.process.subject || "" }}
                </span>
              </div>

              <BookmarkList :bookmarks="props.row.bookmarks" />
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="ordering_status"
            :label="General.STATUS"
            :sortable="!isMobile"
          >
            <div
              v-if="props.row.is_refused"
              class="has-text-color-7 has-text-weight-semibold custom-pointer refused"
              role="button"
              @click="openDetail(props.row)"
            >
              {{ getFileStatus(props.row.status) }}
            </div>

            <div v-else class="has-text-color-8">
              {{ getFileStatus(props.row.status) }}
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="created_at"
            :label="General.DATE"
            :sortable="!isMobile"
          >
            <div class="has-text-color-8">
              {{ new Date(props.row.date) | dateFormat("DD/MM/YYYY HH:mm:ss") }}
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            class="is-narrow"
            field="user.last_name"
            :label="General.ACTIONS"
          >
            <ActionsGrouper
              :actions="sentActionList(props.row)"
              customClass=""
            />
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <NoListMessage v-if="!isLoading" />
            <b-loading v-else :isFullPage="false" :active="isLoading" />
          </section>
        </template>

        <template slot="footer">
          <div class="table-footer">
            <div class="column is-12 number-page pl-0">
              <span
                class="has-text-black column is-12 pl-0 has-text-weight-normal"
              >
                <b-dropdown
                  v-model="perPage"
                  role="listbox"
                  :expanded="isMobile"
                  position="is-top-right"
                >
                  <template slot="trigger">
                    <b-button
                      class="custom-dropdown-button custom-ph-8"
                      role="button"
                    >
                      <label
                        >{{ perPage }}
                        {{ General.PER_PAGE.toLowerCase() }}</label
                      >

                      <b-icon class="spacing-mx-5" icon="chevron-down" />
                    </b-button>
                  </template>
                  <div class="has-text-color-7 spacing-p-5 has-text-centered">
                    {{ General.RECORDS_FOR_PAGE }}
                    <div class="list-page">
                      <b-dropdown-item
                        v-for="option in getItensPage"
                        :key="option"
                        :value="option"
                        role="listitem"
                      >
                        <div>
                          {{ option }}
                        </div>
                      </b-dropdown-item>
                    </div>
                  </div>
                </b-dropdown>
              </span>
            </div>
            <div class="columns is-centered">
              <div class="column is-6">
                <b-pagination
                  :total="getDocumentRequestedSignList.count"
                  :perPage="perPage"
                  :current.sync="currentPage"
                  rangeBefore="1"
                  rangeAfter="1"
                  order="is-centered"
                  class="process-panel-pagination"
                  rounded
                  :iconPrev="prevIcon"
                  :iconNext="nextIcon"
                  :aria-next-label="General.NEXT_PAGE"
                  :aria-previous-label="General.PREVIOUS_PAGE"
                  :aria-page-label="General.PAGE"
                  :aria-current-label="General.CURRENT_PAGE"
                  role="navigation"
                />
              </div>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { debounce } from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";

import { App, General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";
import {
  PROCESS_SIGNING_FILE_TABS as TABS,
  PROCESS_SUBJECT_ICONS as subjectIcons,
  TAB_PERSIST_NAME as PERSIST_NAME,
  USER_PERMISSIONS as userPermissions,
  LIST_TYPE as listType,
  SECRECY as secrecies
} from "@/utils/enumerate";

import UnifiedFilterSearch from "@/components/UnifiedFilterSearch";
import NoListMessage from "@/components/NoListMessage";
import ModalWarning from "@/views/App/ModalWarning.vue";
import modalDeclineRequest from "@/views/App/ModalDeclineRequest";
import BookmarkList from "@/components/BookmarkList.vue";
import ModalCancelSignature from "@/views/App/ModalCancelSignature.vue";
import { createFilterSignature } from "@/utils/filters";
import { formatPagination } from "@/utils/transformers";
import { setPersistSort, getPersistSort } from "@/plugins/indexDB";

export default {
  name: "SignatureRequested",
  components: {
    UnifiedFilterSearch,
    NoListMessage,
    BookmarkList
  },
  data() {
    return {
      App,
      General,
      subjectIcons,
      sortField: "created_at",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      sortIcon: "menu-up",
      sortIconSize: "is-medium",
      currentPage: 1,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      perPage: 10,
      isLoading: true,
      observerPage: true,
      filterList: {},
      searchValue: "",
      documentsSelectedSignRequested: [],
      listType
    };
  },
  computed: {
    ...mapGetters([
      "getDocumentRequestedSignList",
      "getItensPage",
      "isContrast",
      "getCurrentTabSignPanel",
      "getUpdateBySockets",
      "getCurrentUser",
      "isConfidentialCheck",
      "hasPermission",
      "isMobile"
    ]),
    activeTab() {
      return this.getCurrentTabSignPanel.value;
    },
    itensFilter() {
      return [
        "DOCUMENT_TYPE",
        "PROCESS_BOOKMARKS",
        "PROCESS_DATE",
        "PROCESS_CCS",
        "STATUS_SIGNATURE"
      ];
    },
    isValidSelection() {
      return this.documentsSelectedSignRequested.length < 2;
    },
    getPaginationDetails() {
      return formatPagination(
        this.getDocumentRequestedSignList,
        this.currentPage,
        this.perPage,
        "SIMPLIFIED"
      );
    },
    requestBaseData() {
      return {
        page: this.currentPage,
        search: this.searchValue,
        order_by: this.sortField,
        ordenation: this.sortOrder,
        paginator_count: this.perPage,
        filters: createFilterSignature(this.filterList),
        ignore_order_by_default: this.ignoreOrderByDefault
      };
    },
    tabPersistName() {
      return `${PERSIST_NAME.SIGNING_REQUESTED}_${this.getCurrentUser.id}`;
    },
    isCurrentTab() {
      return this.activeTab === TABS.SIGNING_REQUESTED.value;
    },
    hasConfidentialSelected() {
      return this.documentsSelectedSignRequested.some(process =>
        this.isConfidential(process)
      );
    },
    hasPermissionViewConfidential() {
      return this.hasPermission(userPermissions["VIEW_CONFIDENTIAL_PROCESS"]);
    }
  },
  watch: {
    perPage() {
      if (this.currentPage > 1) this.currentPage = 1;
      else this.updataSignatureList();
    },
    currentPage() {
      this.updataSignatureList();
    },
    getUpdateBySockets(value) {
      if (this.isCurrentTab && value === "update_pendant_signature_others") {
        this.currentPage = 1;
        this.getDocumentSign();
        this.clearUpdateBySockets();
      } else if (value === "update_pendant_signature_others") {
        this.documentSignRequested({
          page: 1,
          only_count: true
        });
        this.clearUpdateBySockets();
      }
    },
    filterList: {
      handler() {
        this.updataSignatureList();
      },
      deep: true
    },
    activeTab() {
      if (this.isCurrentTab) {
        if (this.currentPage === 1) this.getDocumentSign();
        else this.currentPage = 1;
      }
    },
    getDocumentRequestedSignList() {
      this.documentsSelectedSignRequested = [];
    },
    requestBaseData(value) {
      this.getDocumentSign(value);
    }
  },
  async created() {
    this.observerPage = false;
    const sortData = await getPersistSort({
      name: this.tabPersistName,
      sort: { [this.sortField]: this.sortOrder }
    });
    const sortString = JSON.stringify(sortData);
    if (sortString !== this.sortField) {
      this.sortOrder = Object.entries(sortData)[0];
      this.observerPage = true;
      this.onSort(...this.sortOrder);
    }
    this.observerPage = true;
  },
  async beforeMount() {
    if (this.isCurrentTab) this.getDocumentSign();
  },
  methods: {
    ...mapActions({
      documentSignRequested: "documentSignRequested",
      getSignatureDocuments: "getSignatureDocuments"
    }),
    ...mapMutations(["clearUpdateBySockets"]),
    updataSignatureList: debounce(function() {
      this.getDocumentSign();
    }, 500),
    setSearchValue: debounce(function(value) {
      this.searchValue = value;
      this.currentPage = 1;
    }, 500),
    setFilterList(filterList) {
      this.filterList = filterList;
      if (this.currentPage !== 1) this.currentPage = 1;
    },
    async getSignatureListCompleteFile() {
      const processFileIdList = this.documentsSelectedSignRequested.map(
        process => process.process_file.id
      );

      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: `${this.General.MESSAGES.ARE_YOU_SURE_YOU_WANT_EXPORT_PROCESSES}? ${this.General.MESSAGES.DISABLE_POPUP}`,
          confirm: async () => {
            await this.getSignatureDocuments(processFileIdList);
            this.snackToast.open({
              message: this.General.MESSAGES.PROCESSES_SUCCESSFULLY_EXPORTED,
              position: "is-top",
              type: "is-success",
              duration: 8000
            });
          }
        },
        hasModalCard: true,
        trapFocus: true
      });
    },
    addZero(number) {
      return (number < 10 ? "0" : "") + number;
    },
    getReceivedDifferenceDate(date) {
      const time = new Date(date);
      return `às ${this.addZero(time.getHours())}h ${this.addZero(
        time.getMinutes()
      )}m`;
    },
    dohandlecumentsSelectedSignRequested() {
      const capacity_id =
        this.documentsSelectedSignRequested.length > 1
          ? this.user.capacity.capacity_id
          : this.documentsSelectedSignRequested[0].capacity;
      this.$store.commit("setListSelectedDocuments", {
        documents: this.documentsSelectedSignRequested,
        capacity_id
      });
    },
    getDocumentSign: debounce(async function() {
      this.isLoading = true;
      if (this.isCurrentTab && this.observerPage)
        await this.documentSignRequested(this.requestBaseData);
      this.isLoading = false;
    }, 1e3),
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.ignoreOrderByDefault = true;
      setPersistSort({ name: this.tabPersistName, sort: { [field]: order } });
      this.getDocumentSign();
    },
    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },
    showDocNameTooltip(docName) {
      return docName.length > 60;
    },
    declineRequest(process = null) {
      if (process?.id) this.documentsSelectedSignRequested = [process];

      this.$buefy.modal.open({
        parent: this,
        component: modalDeclineRequest,
        props: {
          signatureList: this.documentsSelectedSignRequested
        },
        canCancel: ["escape", "x", "outside"],
        onCancel: () => (this.documentsSelectedSignRequested = []),
        hasModalCard: true,
        trapFocus: true
      });
    },
    sentActionList(item) {
      return [
        {
          label: this.General.TO_VIEW,
          icon: "file-eye",
          link: `/app/documento/${item.process_file.id}?processId=${item.process_file.process.id}`
        },
        {
          label: this.General.CANCEL_REQUEST,
          icon: "delete",
          validated: item.status !== "SIGNED",
          callback: () => this.cancelSignatureModal(item)
        }
      ];
    },
    async cancelSignatureModal(signature = null) {
      if (signature?.id) this.documentsSelectedSignRequested = [signature];

      this.$buefy.modal.open({
        parent: this,
        component: ModalCancelSignature,
        props: {
          listSignature: this.documentsSelectedSignRequested,
          onClose: this.updataSignatureList
        },
        canCancel: ["escape", "x", "outside"],
        onCancel: () => (this.documentsSelectedSignRequested = []),
        hasModalCard: true,
        trapFocus: true
      });
    },
    getFileStatus(fileStatus) {
      const status = {
        PENDING: "Pendente",
        SIGNED: "Assinado",
        PARTIALLY: "Parcialmente",
        REFUSED: "Recusado"
      };
      return status[fileStatus] || "";
    },
    secrecyName(item) {
      const process = item.process_file.process;
      return (
        secrecies.find(secrecy => secrecy.id === process.secrecy).name || ""
      );
    },
    isConfidential(item) {
      return this.isConfidentialCheck(item.process_file.process.secrecy);
    },
    validateConfidentialView() {
      if (!this.hasPermissionViewConfidential) {
        this.snackToast.open({
          message: this.General.TEXTS.CONFIDENTIAL_VIEW_WARNING,
          position: "is-top",
          type: "is-warning",
          duration: 8000
        });
        return false;
      }
      return true;
    },
    checkIsConfidential(callback = () => null) {
      if (this.hasConfidentialSelected) {
        const hasConfidentialPermission = this.validateConfidentialView();
        if (!hasConfidentialPermission) return;

        this.$buefy.modal.open({
          parent: this,
          component: ModalWarning,
          props: {
            title: `${this.General.WARNING}!`,
            message: this.General.MESSAGES.ALERT_DOCUMENT_SECRECY,
            invertOutline: true,
            confirm: callback,
            buttons: [
              { label: General.YES, isConfirm: true, action: true },
              { label: General.NO, isConfirm: false, action: false }
            ]
          },
          hasModalCard: true,
          trapFocus: true
        });
      } else {
        callback();
      }
    }
  }
};
</script>
